export { default } from './content-box'
export type { Props as ContentBoxProps } from './content-box'
